import Lightbox from 'yet-another-react-lightbox'
import Captions from 'yet-another-react-lightbox/plugins/captions'
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails'
import Counter from 'yet-another-react-lightbox/plugins/counter'
import 'yet-another-react-lightbox/styles.css'
import 'yet-another-react-lightbox/plugins/captions.css'
import 'yet-another-react-lightbox/plugins/thumbnails.css'
import 'yet-another-react-lightbox/plugins/counter.css'

export default function GalleryLightbox({ slides, open, index, onClose }) {
  return (
    <Lightbox
      open={open}
      index={index}
      close={onClose}
      slides={slides}
      plugins={[Captions, Thumbnails, Counter]}
      styles={{
        container: { backgroundColor: 'rgba(26,10,46,0.97)' },
      }}
      counter={{ container: { style: { top: 0, bottom: 'unset' } } }}
    />
  )
}
